import React, {CSSProperties, useEffect, useRef, useState} from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { RootState, useAppDispatch } from '../../../redux/store'
import { BsTrash } from "react-icons/bs"
import { conseguirDetallesDeGuiaEnRuta, limpiarDetallesDeGuiaEnRuta, obtenerMotivosDevolucion } from '../../../redux/actions/actionsLiquidacionRutas'
import {LogisticaTiposFormaPago, LogisticaTipoFormaPagoDominio, DocumentoDominio, BigDecimal, CobroDTO} from "@pcgerente-node/pcg-comun"
import { logistica_GUIA } from '@pcgerente-node/pcg-comun/dist/DTOs'
import Loading from '../../helpers/Loading/Loading'
import ModalAgregarCobro from './ModalAgregarCobro'
import { ReduxHelper, ArchivoImagen, coordenadas, obtenerCoordenadas } from '../../../Utils/funciones'
import service from './serviceDetallesLiquidacionRutaDetalles';
import AbrirUbicacion from "../../helpers/GoogleMaps/AbrirUbicacion";
import style from "../../../styles/cardPago.module.css"

const StylePropsSelect: CSSProperties = { color: "white", backgroundColor: "#ff5800", border: "1px solid black", padding: "4px 4px" }
const StyleProps1: CSSProperties = { backgroundColor: "#d9d9f3", border: "1px solid #304aca", paddingLeft: "0.6rem" };
const StyleProps2: CSSProperties = { color: "black", };
const StyleProps3: CSSProperties = { color: "#304aca", textAlign: 'center' };


const LiquidacionRutasDetalle = () => {

    const {uuidManifiestoDetalle = ""} = useParams() //sacado de URL
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const motivosDevolucion = useSelector((state: RootState) => state.liquidacionRutas.motivosDevolucion)
    const guiaStore = useSelector((state: RootState) => state.liquidacionRutas.detalleGuiaEnRuta)

    const [fotos, setfotos] = useState<ArchivoImagen[]>([])
    const [guiaLocal, setGuiaLocal] = useState(getEstadoGuiaInicial)
    const [cobros, setCobros] = useState<CobroDTO[]>([]);
    const [coordenadas, setCoordenadas] = useState<coordenadas>({cargando: true})
    const [mensajeError, setMensajeError] = useState<string>("")
    const [exitoAlGuardarGuia, setExitoAlGuardarGuia] = useState<boolean>(false)

    const guiaStoreSolicitada = useRef(false)

    useEffect(() => {
        if (!guiaStoreSolicitada.current) {
            dispatch(conseguirDetallesDeGuiaEnRuta(uuidManifiestoDetalle, ReduxHelper.IdUsuario()))
            guiaStoreSolicitada.current = true

            dispatch(obtenerMotivosDevolucion())
        }

        obtenerCoordenadas()
            .then((coords) => setCoordenadas(coords))
            .catch((err: string) => {
                alert(err)
                setCoordenadas((prev) => ({...prev, cargando: false}))
            })
            .finally(() => {
                setCoordenadas((prev) => ({...prev, cargando: false}))
            })
        return () => limpiar();
    }, [])

    useEffect(() => {
        if (exitoAlGuardarGuia) {
            const timeout = setTimeout(() => {
                navigate('/home/liquidarRuta');
            }, 1500); // Redirecciona después de 1.5 segundos para que el usuario vea el mensaje de éxito

            return () => clearTimeout(timeout);
        }
    }, [exitoAlGuardarGuia, navigate])

    useEffect(() => {
        const guiaDB = guiaStore.info

        if (guiaStoreSolicitada.current && guiaDB.id!! > 0) {
            setGuiaLocal({
                ...guiaDB,
                entregada: guiaDB.entregada ?? false,
                personaEntrega: guiaDB.personaEntrega ?? "",
                novedadesEntrega: guiaDB.novedadesEntrega ?? "",
                logistica_GUIA_FOTOS: guiaDB.logistica_GUIA_FOTOS ?? [],
            })
        }
    }, [guiaStore.info])

    function getEstadoGuiaInicial() {
        const guia = new logistica_GUIA();
        guia.logistica_GUIA_FOTOS = [];
        guia.personaEntrega = "";
        guia.entregada = false;
        guia.novedadesEntrega = "";

        return guia
    }

    function limpiar() {
        setCobros([]);
        setfotos([]);
        setGuiaLocal(getEstadoGuiaInicial());
        setMensajeError("");
        setExitoAlGuardarGuia(false);
        guiaStoreSolicitada.current = false;
        dispatch(limpiarDetallesDeGuiaEnRuta())
    }

    function handleInfo(value: string, campo: "personaEntrega" | "novedadesEntrega" | "idMotivoDevolucion") {
        if (campo === "idMotivoDevolucion") {
            setGuiaLocal({
                ...guiaLocal,
                idMotivoDevolucion: Number(value)
            })
        }

        if ((campo === "personaEntrega" && value.length <= 200) || (campo === "novedadesEntrega" && value.length <= 50)) {
            setGuiaLocal({
                ...guiaLocal,
                [campo]: value
            })
        }
    }

    async function handleGuardar() {
        const btnGuardar = window.document.getElementById("btn-guardarGuiaEnRuta") as HTMLButtonElement
        btnGuardar.disabled = true

        const msgError = await service.Guardar(guiaLocal, fotos, coordenadas, cobros, uuidManifiestoDetalle)

        setExitoAlGuardarGuia(msgError.length === 0)
        setMensajeError(msgError)

        btnGuardar.disabled = false
    }

    return (
        (guiaStoreSolicitada.current && !guiaStore.loading) && guiaLocal?
            !guiaStore.errorUndefined && guiaStoreSolicitada.current?
                <div id="content" className="main-content">
                    <div className="p-3">
                        <h4 style={StyleProps3} className="mb-4">
                            {guiaLocal.CLIENTE_DESTINATARIO?.razonSocial}
                        </h4>

                        {(guiaLocal.latitud && guiaLocal.longitud)?
                            <AbrirUbicacion
                                latitude={guiaLocal.latitud}
                                longitude={guiaLocal.longitud}
                            />
                            :<></>
                        }
                        <div className='pb-3 mb-2'>
                            <label style={StyleProps2}> Recibe: </label>
                            <input
                                onChange={(e) => handleInfo(e.target.value, "personaEntrega")}
                                className="form-control-plaintext"
                                style={{
                                    backgroundColor: "#d9d9f3",
                                    border: "1px solid #304aca",
                                    paddingLeft: "0.6rem"
                                }}
                                value={guiaLocal.personaEntrega}
                            />
                        </div>

                        {coordenadas.cargando?
                            <span>Obteniendo coordenadas...</span>
                            : coordenadas?.latitud && coordenadas?.longitud ?
                                <span>Mis Coordenadas: {`${coordenadas.latitud.toString()},${coordenadas.longitud.toString()}`}</span>
                                : <span>Error al intentar obtener coordenadas...</span>
                        }

                        <div className="d-flex pb-3 align-items-center">
                            <div className='pr-5 mt-3'>
                                <label style={StyleProps2}>Entregada:</label>
                                <div className='d-flex align-items-center'>
                                    <label className={`switch ${guiaLocal.entregada? "s-success": "s-danger"}`} style={{ "scale": "1.5", "margin": ".5rem " }}>
                                        <input
                                            type="checkbox"
                                            checked={guiaLocal.entregada}
                                            onChange={() => {}}
                                        />
                                        <span className="slider round" onClick={() => setGuiaLocal({
                                            ...guiaLocal,
                                            entregada:!guiaLocal.entregada,
                                            idMotivoDevolucion: undefined,
                                        })}></span>
                                    </label>
                                    <span className='pl-2' >{guiaLocal.entregada ? "Sí" : "No"}</span>
                                </div>
                            </div>

                            {!guiaLocal.entregada?
                                <div className='w-100 pl-1 '>
                                    <label style={StyleProps2}>Motivo de devolución: </label>
                                    <select name="country_code"
                                            className="form-control country_code"
                                            style={StylePropsSelect}
                                            color="white" id="payment-method-country"
                                            disabled={guiaLocal.entregada}
                                            value={guiaLocal.idMotivoDevolucion || 0}
                                            onChange={(e) => handleInfo(e.target.value, "idMotivoDevolucion")}
                                    >
                                        <option hidden value={0}>Escoja un motivo de devolución</option>
                                        {motivosDevolucion.info.map(motivo =>
                                            <option value={motivo.id} key={motivo.id}>{motivo.descripcion}</option>
                                        )}
                                    </select>
                                </div>
                                :<></>
                            }
                        </div>

                        <div className='pb-3'>
                            <label style={StyleProps2}> Novedades Entrega: </label>
                            <textarea
                                className="form-control-plaintext"
                                style={StyleProps1}
                                value={guiaLocal.novedadesEntrega}
                                onChange={(e) => handleInfo(e.target.value, "novedadesEntrega")}
                            />
                        </div>
                        <div className='pb-3'>
                            <label htmlFor="formFileMultiple" className="form-label">Subir imágenes:</label>
                            <input
                                className="form-control"
                                type="file"
                                id="formFileMultiple"
                                multiple
                                accept=".jpeg,.jpg,.png,.tif"
                                onChange={(e) => service.handleImagenes(e.target.files, fotos, setfotos,)}
                            />
                        </div>

                        {/* Contenedor imagenes */}
                        <div className="d-flex flex-wrap align-items-start">
                            {fotos?.map((foto, i) => (
                                <div key={i} className="p-2 text-center position-relative">
                                    <img
                                        src={foto.urlLocal}
                                        style={{ maxWidth: "250px", borderRadius: "4px" }}
                                        alt={`Foto ${i + 1} `}
                                    />

                                    <button
                                        type="button"
                                        className="btn btn-danger position-absolute"
                                        style={{
                                            top: "5px",
                                            right: "5px",
                                            padding: "0.3rem 0.7rem",
                                            borderRadius: "0.25rem",
                                        }}
                                        onClick={() => service.EliminarImagen(foto.urlLocal, fotos, setfotos)}
                                        disabled={exitoAlGuardarGuia}
                                        aria-label={`Eliminar foto ${i + 1}`}
                                    >
                                        <BsTrash />
                                    </button>
                                </div>
                            ))}
                        </div>

                        <div className='d-flex pb-3 justify-content-between' style={{ maxWidth: "500px" }}>
                            <div className='d-flex flex-column flex-wrap'>
                                <label style={StyleProps2}> Destinatario </label>
                                <span>{guiaLocal.CLIENTE_DESTINATARIO?.razonSocial}</span>
                            </div>

                            <div className='d-flex flex-column'>
                                <label style={StyleProps2}> Llamar </label>
                                <div>
                                    {guiaLocal.CLIENTE_DESTINATARIO?.celular ?
                                        <div>
                                            celular:
                                            <a target="_blank" className='text-primary' rel="noreferrer" href={`tel:${guiaLocal.CLIENTE_DESTINATARIO.celular}`}>{` ${guiaLocal.CLIENTE_DESTINATARIO.celular}`}</a>
                                        </div> : <></>
                                    }
                                    {guiaLocal.CLIENTE_DESTINATARIO?.telefono ?
                                        <span className='p'> telefono:
                                            <a target="_blank" className='text-primary' rel="noreferrer" href={`tel:${guiaLocal.CLIENTE_DESTINATARIO.telefono}`}>{` ${guiaLocal.CLIENTE_DESTINATARIO.telefono}`}</a>
                                        </span> : <></>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className='d-flex pb-3 justify-content-between' style={{ maxWidth: "500px" }}>
                            <div className='d-flex flex-column pr-5 flex-wrap'>
                                <label style={StyleProps2}> Tipo forma de pago: </label>
                                <span>{LogisticaTipoFormaPagoDominio.obtener(guiaLocal.tipo).descripcion}</span>
                            </div>

                            <div className='d-flex flex-column  flex-wrap'>
                                <label style={StyleProps2}> fecha de Emisión: </label>
                                <span>{new Date(guiaLocal.fechaEmision).toLocaleString()}</span>
                            </div>
                        </div>

                        <div className='d-flex pb-2 justify-content-between align-items-center' style={{ gap: "1rem", maxWidth: "500px" }}>
                            <div className='d-flex flex-column w-25 '>
                                <label style={StyleProps2}> Documento: </label>
                                <span>{DocumentoDominio.obtener(guiaLocal.idDocumento).descripcion.toUpperCase()}</span>
                            </div>

                            <div className='d-flex flex-column ml-4'>
                                <label style={StyleProps2}> Serie 1: </label>
                                <span>{guiaLocal.serie1}</span>
                            </div>

                            <div className='d-flex flex-column'>
                                <label style={StyleProps2}> Serie 2: </label>
                                <span>{guiaLocal.serie2}</span>
                            </div>

                            <div className='d-flex flex-column'>
                                <label style={StyleProps2}> Número: </label>
                                <span>{guiaLocal.numeroDocumento}</span>
                            </div>
                        </div>


                        <div className='d-flex pb-3 justify-content-between align-items-center' style={{ maxWidth: "380px" }}>
                            <div className='d-flex flex-column '>
                                <label style={StyleProps2}> Total: </label>
                                <span>${new BigDecimal(guiaLocal.total).toFixed(2)}</span>
                            </div>

                            <div className='d-flex flex-column '>
                                <label style={StyleProps2}>Saldo Por Pagar:</label>
                                <input
                                    type='text'
                                    className="form-control-plaintext"
                                    style={{
                                        backgroundColor: "#d9d9f3",
                                        paddingLeft: "0.6rem",
                                        width: "8rem",
                                        color: service.PermiteAgregarCobro(guiaLocal)? "#2b2b2b": undefined
                                    }}
                                    disabled ={!service.PermiteAgregarCobro(guiaLocal)}
                                    value={`$${service.ObtenerSaldoPorPagar(guiaLocal, cobros).toFixed(2)}`}
                                    onChange={() => { }}
                                />
                            </div>
                        </div>

                        <div className='d-flex pb-3 justify-content-between' style={{ maxWidth: "380px" }}>
                            <div className='d-flex flex-column'>
                                <label style={StyleProps2}> Saldo Original: </label>
                                {
                                    guiaLocal.tipo === LogisticaTiposFormaPago.FleteCobro &&
                                    new BigDecimal(guiaLocal.FACTURA?.saldoPorPagar).greaterThan(0) ?
                                        <span>${new BigDecimal(guiaLocal.FACTURA?.saldoPorPagar).toFixed(2)}</span>
                                        :<span>${new BigDecimal(0).toFixed(2)}</span>
                                }
                            </div>

                            <div className='d-flex flex-column'>
                                <label style={StyleProps2}> Cobros Totales: </label>
                                <span>${service.CalcularTotalCobros(cobros).toFixed(2)}</span>
                            </div>
                        </div>

                        <div className='d-flex pb-3 justify-content-between' style={{ maxWidth: "380px" }}>
                            <div className='d-flex flex-column'>
                                <label style={StyleProps2}> Seguro: </label>
                                <span>
                                        {new BigDecimal(guiaLocal.seguro || 0).greaterThan(0) ?
                                            `$${new BigDecimal(guiaLocal?.seguro).toFixed(2)}`
                                            :"NO"
                                        }
                                    </span>
                            </div>
                        </div>
                    </div>

                    {! service.AgregarCobroCanExecute(guiaLocal)?
                        <></>
                        :<div className="pl-2">
                            <div className='d-flex flex-wrap mb-2'>
                                {cobros.length === 0?
                                    <span>Aún no hay cobros registrados </span>
                                    :cobros.map((cobro, index) =>
                                        <div className={style.cardCobroContainer} key={index}>
                                            <div className='flex-column w-75 justify-content-start'>
                                                    <span className='text-dark'>
                                                        {cobro.FORMAPAGO?.descripcion}
                                                    </span> <br/>
                                                <span className='text-dark w-25 font-weight-bolder'>
                                                        ${new BigDecimal(cobro.monto).toFixed(2)}
                                                    </span>
                                            </div>
                                            <button
                                                className={`btn btn-danger ml-2 mr-1' ${style.btnBorrarCobro}`}
                                                onClick={() => service.borrarCobro(cobro, cobros, setCobros)}
                                            >
                                                <BsTrash />
                                            </button>
                                        </div>
                                    )}
                            </div>
                            <ModalAgregarCobro
                                idCiudadDestino={service.ObtenerIdCiudadDestinoManifiesto(guiaLocal)}
                                idCiudadUsario={ReduxHelper.IdCiudadUsuario()}
                                idBodegaUsuario={ReduxHelper.IdBodegaUsuario()}
                                cobros={cobros}
                                setCobros={setCobros}
                                saldoPendiente={service.CalcularSaldoPendiente(guiaLocal, cobros)}
                            />
                        </div>
                    }
                    <div className="mt-3">
                        {mensajeError ?
                            <span className='text-danger pt-1 ml-1 pb-2'>
                                {mensajeError}
                            </span>
                            : <span className='text-success pt-1 pb-2 m-4'>
                                {exitoAlGuardarGuia?"La Guia se actualizo correctamente": ""}
                            </span>
                        }
                    </div>
                    <div className='d-flex justify-content-center mb-4'>
                        {!exitoAlGuardarGuia ?
                            <button
                                className='d-flex btn btn-success m-1 ml-5'
                                id='btn-guardarGuiaEnRuta'
                                onClick={() => handleGuardar()}
                            >
                                Guardar Cambios
                            </button>
                            : <Link to={"/home/liquidarRuta"} className='d-flex justify-content-center'>
                                <button className='btn btn-primary m-1 ml-5' >Regresar</button>
                            </Link>
                        }

                    </div>
                </div>
                : <div id="content" className="main-content"> {/*Error del Backend*/}
                    <h3 className="mt-4 text-danger p-4 text-center">Error: {guiaStore.errorUndefined}</h3>
                    <Link to={"/home/liquidarRuta"} className='d-flex justify-content-center'>
                        <button className='btn btn-primary m-1 ml-5'>Regresar</button>
                    </Link>
                </div>
            :
            <div id="content" className="main-content">
                <Loading />
            </div>
    )
}


export default LiquidacionRutasDetalle